import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import TopBar from '../../components/TopBar'
import { getSubscriber, updateSubscriber } from '../../api/subscribersApi'
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup'
import styles from './page.module.css'

const EditSubscriber = () => {
    const { id } = useParams()

    const [errors, setErrors] = useState({})
    const [formData, setFormData] = useState({
        name: "",
        city: "",
        mobileNumber: ""
    })
    const [isLoading, setIsLoading] = useState(false)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    useEffect(() => {
        if (!id) return;


        const fetchSubscriber = async () => {
            try {
                const response = await getSubscriber(id);

                if (response?.success) {
                    setFormData({
                        ...response.data,
                    });
                }
            } catch (error) {
                console.log("Failed to fetch subscriber:", error);
            }
        };

        fetchSubscriber();
    }, [id]);

    const validateForm = () => {
        let newErrors = {};

        if (!formData?.name.trim()) {
            newErrors.name = "Name is required";
        }

        const phoneRegex = /^[0-9]{10}$/;
        if (!formData?.mobileNumber?.trim()) {
            newErrors.mobileNumber = "Mobile number is required";
        } else if (!phoneRegex.test(formData?.mobileNumber)) {
            newErrors.mobileNumber = "Enter valid 10-digit phone number";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        try {
            setIsLoading(true)
            const response = await updateSubscriber(id, {
                name: formData?.name,
                city: formData?.city,
                mobileNumber: formData?.mobileNumber,
            });
            if (response?.success) {
                setIsLoading(false)
            }
        } catch (error) {
            setIsLoading(false)
            console.log({ error })
        }
    };

    return (
        <div>
            <TopBar />
            <div className={styles.generalContent}>
                <div className={styles.generalRow}>
                    <div className={styles.formControltems}>
                        <div className={styles.formControlInputs}>
                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Name</label>
                                <input
                                    type="text"
                                    value={formData?.name}
                                    className={styles.inputFields}
                                    onChange={(e) => {
                                        setFormData({ ...formData, name: e.target.value });
                                        setErrors(prev => ({ ...prev, name: "" }));
                                    }}

                                    autoComplete="off"
                                    placeholder='Enter name'
                                />
                                {errors.name && (
                                    <div className='error-message'>{errors.name}</div>
                                )}
                            </div>

                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Mobile number</label>
                                <div className={styles.inputFieldsIcon}>
                                    <input
                                        className={styles.inputFields}
                                        type="number"
                                        value={formData?.mobileNumber}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            setFormData({ ...formData, mobileNumber: e.target.value });
                                            setErrors(prev => ({ ...prev, mobileNumber: "" }));
                                        }}
                                        placeholder='Enter mobile number'
                                    />
                                </div>

                                {errors.mobileNumber && (
                                    <div className='error-message'>{errors.mobileNumber}</div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>

                <div className={styles.generalRow}>
                    <div className={styles.formControltems}>
                        <div className={styles.formControlInputs}>
                            <div className={styles.formControlFields}>
                                <label className={styles.fieldsLabel}>Location</label>
                                <div className={styles.inputFieldsIcon}>
                                    <input
                                        className={styles.inputFields}
                                        type="text"
                                        value={formData?.city}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            setFormData({ ...formData, city: e.target.value });
                                        }}
                                        placeholder='Enter location'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showDeleteConfirmation && (
                    <DeleteConfirmationPopup
                        showDeletePopup={showDeleteConfirmation}
                        setShowDeletePopup={setShowDeleteConfirmation}
                        title="Subscriber"
                        description="Are you sure you want to delete this subscriber?"
                        confirmDelete={() => {
                            setShowDeleteConfirmation(false);
                        }}
                    />
                )}
            </div>
            <div className={`${styles.buttonsGroup} ${styles.buttonSaveLast}`}>

                <button className={`${styles.saveButton} ${styles.saveChangeButton}`} onClick={() => { handleSave() }}>
                    {
                        isLoading ? <div className={`ringLoader loaderContinue`}></div> : 'Save Changes'
                    }
                </button>
            </div>
        </div>
    )
}

export default EditSubscriber
